import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LabelValue } from "../declarations/interface";
import globalService from "../services/globalService";

export const getDynamicApiList: any = createAsyncThunk('global/getDynamicApiList', async () => {
  return globalService.getDynamicApiList()
});

export const getDownloadOptions: any = createAsyncThunk('global/getDownloadOptions', async () => {
  return globalService.getDownloadOptions()
});

const DEFAULT: {
  dynamicApis: LabelValue[];
  downloadOptions: LabelValue[];
  status: {
    type: 'SUCCESS' | 'FAILURE' | 'ERROR';
    message: string;
  } | null;
} = {
  dynamicApis: [],
  downloadOptions: [],
  status: null,
}

const slice = createSlice({
  name: "global",
  initialState: DEFAULT,
  reducers: {
    clearStatus(state) {
      state.status = null
    }
  },
  extraReducers: {
    [getDynamicApiList.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.dynamicApis = [
        { label: 'None', value: '' },
        ...data.map((datum: { name: string; key: string }) => ({
          label: datum.name, value: datum.key
        }))
      ]

    },
    [getDynamicApiList.rejected]: state => {
      state.status = {
        type: 'FAILURE',
        message: 'Error while fetching projects'
      }
    },
    [getDownloadOptions.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.downloadOptions = [
        { label: 'None', value: '' },
        ...data.map((datum: { name: string; key: string }) => ({
          label: datum.name, value: datum.key
        }))
      ]

    },
    [getDownloadOptions.rejected]: state => {
      state.status = {
        type: 'FAILURE',
        message: 'Error while fetching projects'
      }
    }
  }
});

export const reducer = slice.reducer;
export const actions = slice.actions;

export default slice;
